import { useEffect, useContext, useState } from "react";
import { DatabaseValue } from "../contexts/database";
import styles from "./styles.module.css";
import Dynamic from "./dynamic";
import { Select, Option } from "../select";

export default function DataFilters({ value, onChange, params }) {
  const [_value, setValue] = useState({});
  const tables = useContext(DatabaseValue);
  const [tableSchema, setTableSchema] = useState(null);

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
      setValue({});
    }
  }, [value]);

  useEffect(() => {
    const table = tables.find((x) => x.id === params.type);
    if (table) {
      setTableSchema(table.fields);
    }
  }, [params.type]);

  const onSelect = (value) => {
    const Value = { ..._value };
    Value[value] = { field: value, opperation: "=", value: [""] };
    setValue(Value);
  };

  const handleDelete = (v) => {
    const Value = { ..._value };

    delete Value[v.field];
    setValue(Value);
    onChange(Value);
  };

  const handleChange = (v) => {
    const Value = { ..._value };
    Value[v.field] = v;
    setValue(Value);
    onChange(Value);
  };

  if (!tableSchema) {
    return null;
  }

  return (
    <div>
      {Object.keys(_value).map((key) => {
        return (
          <FilterItem
            filter={_value[key]}
            fieldName={tableSchema[key].name}
            fieldType={tableSchema[key].type}
            fieldList={tableSchema[key].list}
            key={key}
            onDelete={() => handleDelete(_value[key])}
            onChange={handleChange}
          />
        );
      })}
      <Select onChange={(v) => onSelect(v)} value={""}>
        {Object.keys(tableSchema)
          .sort((key1, key2) => {
            if (tableSchema[key1].name > tableSchema[key2].name) {
              return 1;
            }
            return -1;
          })
          .filter((x) => !_value[x])
          .map((key) => {
            return (
              <Option key={key} value={key}>
                {tableSchema[key].name}
              </Option>
            );
          })}
      </Select>
    </div>
  );
}

const FilterItem = ({
  filter,
  fieldName,
  fieldType,
  fieldList,
  onDelete,
  onChange,
}) => {
  const handleChange = (v, key) => {
    const _filter = { ...filter };
    _filter[key] = v;
    onChange(_filter);
  };
  return (
    <div className={styles.filterItem}>
      <div className={styles.spaceTitle}>{fieldName}</div>
      <div style={{ display: "flex" }}>
        <OpperationSelect
          value={filter.opperation}
          type={fieldType}
          onChange={(v) => handleChange(v, "opperation")}
          list={fieldList}
        />
        {!filter.opperation.includes("NULL") &&
          !filter.opperation.includes("empty") && (
            <div
              style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
            >
              <Dynamic
                value={filter.value}
                onChange={(v) => {
                  handleChange(v, "value");
                }}
                params={{ type: fieldType, list: false }}
                sources={[]}
              />
            </div>
          )}
      </div>
      <div
        style={{ fontSize: 12, cursor: "pointer" }}
        className={styles.delete}
        onClick={onDelete}
      >
        Delete
      </div>
    </div>
  );
};

const OpperationSelect = ({ type, list, onChange, value }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let _options = [];
    if (list) {
      _options = [
        { name: "contains", value: "contains" },
        { name: "doesn't contain", value: "!contains" },
        { name: "is empty", value: "emptyarray" },
        { name: "is not empty", value: "!emptyarray" },
      ];
      return setOptions(_options);
    } else if (type === "Number" || type === "Date" || type === "Text") {
      _options = [
        { name: ">", value: ">" },
        { name: "<", value: "<" },
      ];
    }
    const options = [
      { name: "=", value: "=" },
      { name: "not =", value: "!=" },
      { name: "is empty", value: "IS NULL" },
      { name: "not empty", value: "IS NOT NULL" },
      ..._options,
    ];
    setOptions(options);
  }, [type, list]);
  return (
    <select
      style={{
        width: "fit-content",
        fontSize: 12,
        padding: 4,
        textAlign: "center",
        marginRight: 4,
        height: 37,
      }}
      className="dropdown"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((o) => {
        return <option value={o.value}>{o.name}</option>;
      })}
    </select>
  );
};
